import type { Routes } from '@angular/router';

import { authGuard } from '@app/auth/auth.guard';
import { redirectToHomeGuard } from '@app/auth/redirect-to-home.guard';

export const authRoutes: Routes = [
    {
        path: 'oauth2/authorize',
        loadComponent: () =>
            import('@app/auth/oauth-consent/oauth-consent.component').then(
                m => m.OAuthConsentComponent,
            ),
        data: {
            title: 'Authorize Application',
        },
        canActivate: [authGuard],
    },
    {
        path: 'login',
        loadComponent: () => import('@app/auth/login/login.component').then(m => m.LoginComponent),
        data: {
            title: 'Login Page',
        },
        canActivate: [redirectToHomeGuard],
    },
    {
        path: 'sso-refresh',
        loadComponent: () =>
            import('@app/auth/sso-login/sso-login.component').then(m => m.SSOLoginComponent),
        data: {
            title: 'SSO Login',
        },
    },
    {
        path: 'logout',
        loadComponent: () =>
            import('@app/auth/logout/logout.component').then(m => m.LogoutComponent),
        data: {
            title: 'Logout Page',
        },
    },
];
